import { Box, Divider, Grid } from '@mui/material'
import ReactApexChart from 'react-apexcharts'

import AppTable from '../../../components/AppTable/AppTable'

export default function GMVOrderTab({
    chartOptions,
    chartSeries,
    highlights = {},
    rows = [],
    pagination = {},
    loading = false,
    onPageChange,
    formatMoney,
    renderTrend,
}) {
    const highestGmvDay = highlights.highest_gmv_day || {}
    const peakOrderHour = highlights.peak_order_hour || {}
    const mostUsedChannel = highlights.most_used_channel || {}
    const topPaymentMethod = highlights.top_payment_method || {}

    const columns = [
        { field: 'date', header: 'DATE', minWidth: 120 },
        {
            field: 'gmv',
            header: 'GMV',
            render: (row) => <b>{formatMoney(row.gmv)}</b>,
        },
        {
            field: 'vs_yesterday',
            header: 'VS YESTERDAY',
            render: (row) => renderTrend(row.vs_yesterday, '-'),
        },
        { field: 'orders', header: 'ORDERS' },
        {
            field: 'aov',
            header: 'AOV',
            render: (row) => <>{formatMoney(row.aov)}</>,
        },
        { field: 'dine_in', header: 'DINE IN' },
        { field: 'takeaway', header: 'TAKEAWAY' },
        { field: 'preorder', header: 'PRE ORDER' },
    ]

    return (
        <Box className="gmv-order-tab">
            <Grid container spacing={2}>
                <Grid item sm={3} xs={6}>
                    <div className="gmv-order-card">
                        <span>Highest GMV day</span>
                        <h2>{formatMoney(highestGmvDay.gmv)}</h2>
                        <span>{highestGmvDay.date ? new Date(highestGmvDay.date).toLocaleDateString('en-MY', { weekday: 'short', day: '2-digit', month: 'short' }) : '-'}</span>
                    </div>
                </Grid>
                <Grid item sm={3} xs={6}>
                    <div className="gmv-order-card">
                        <span>Peak order hour</span>
                        <h2>{peakOrderHour.hour_label || '-'}</h2>
                        <span>{peakOrderHour.orders ?? 0} orders</span>
                    </div>
                </Grid>
                <Grid item sm={3} xs={6}>
                    <div className="gmv-order-card">
                        <span>Most used channel</span>
                        <h2>{mostUsedChannel.channel?.replaceAll('_', ' ').toUpperCase() || '-'}</h2>
                        <span>{mostUsedChannel.pct ?? 0}% of orders</span>
                    </div>
                </Grid>
                <Grid item sm={3} xs={6}>
                    <div className="gmv-order-card">
                        <span>Top payment method</span>
                        <h2>{topPaymentMethod.method || '-'}</h2>
                        <span>{topPaymentMethod.pct ?? 0}% of transactions</span>
                    </div>
                </Grid>
            </Grid>

            <div className="report-card">
                <div className="report-card__header report-card__header--stacked">
                    <strong>GMV trend - last 7 days</strong>
                    <span>Current vs previous 7-day period</span>
                </div>
                <div className="gmv-comparison-chart">
                    <ReactApexChart
                        options={chartOptions}
                        series={chartSeries}
                        type="bar"
                        height={390}
                    />
                </div>
            </div>

            <div className="flex-container merchant-details-stat-label">
                DAILY BREAKDOWN <Divider style={{ flexGrow: 1 }} />
            </div>
            <AppTable
                columns={columns}
                rows={rows}
                pagination={pagination}
                loading={loading}
                onPageChange={onPageChange}
            />
        </Box>
    )
}
